module.exports = __webpack_public_path__ + "static/media/request-placed.caee01d5.png";